import { useEffect, useState } from "react";

export const useDebouncer = (value: any, delay: number) => {
  const [debouncerValue, setDebouncerValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncerValue(value);
    }, delay);

    return () => clearTimeout(timeout);
  }, [value]);

  return debouncerValue;
};
